module.exports = __webpack_public_path__ + "1fce0c2443c59fecd05c19b0954bbee3.svg";